import PouchDb from 'pouchdb';
import { GenericObject } from '@/includes/definitions/index.d';

export default class DictionaryDatabase<T=GenericObject> {
  private db: PouchDB.Database;

  constructor(name: string) {
    this.db = new PouchDb(name);
  }

  async info() {
    return this.db.info();
  }

  async batchInsert(documents: T[]) {
    return this.db.bulkDocs(documents);
  }

  async prefixSearch(query: string): Promise<T[]> {
    const documents = await this.db.allDocs<T>({
      key: query,
      limit: 20,
      include_docs: true,
    });
    const documents2 = await this.db.allDocs<T>({
      startkey: query,
      limit: 20,
      include_docs: true,
    });
    const docMap = new Map<string, boolean>();
    const d2: T[] = [];
    const d1 = [...documents.rows, ...documents2.rows];
    d1.forEach((doc) => {
      if (!docMap.has(doc.id)) {
        docMap.set(doc.id, true);
        d2.push(doc.doc);
      }
    });

    return d2;
  }

  async destroy() {
    return this.db.destroy();
  }
}
